module.exports = __webpack_public_path__ + "static/BlueNotes-c43cd67d32dc51b03b92d068bb08d05f.jpg";